import React from "react";

export const Level = (props) => {
  return (
    <div id="level">
      <div className="container">
        <div className="col-md-12 text-center">
          <img src="img/title-level-choose.png" className="img-title" alt="" />
        </div>
        <div className="row text-center">
          <div className="col-md-12">
            <div className="level">
              <img src="img/level/11.png" className="img-title" alt="" />
              <a href="line://app/2007605903-BR0b43NW?_ads=Home_header_line">
                <img src="img/level-icon.png" className="icon-level" alt="" />
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
